/**
 *@author yudeping
 *文本区控件
 */

import Component from '../../../lib/component';
import template from './textarea-control.html';
import './textarea-control.scss';
import WXtemplate from './textarea-control.wx.html'
import BaseControl from '../WXbase-control/WXbase-control';
let config={
    template:template,
	actions:{
    	init(){
		    this.actions.bindInputEvent();
		    //监测，如果是edge浏览器，textarea不适用disabled属性（解决没有滚动条的问题)(readonly即能达到不可编辑的要求)
			if(navigator.userAgent.indexOf("Edge") > -1){
				this.el.find('.ui-width').attr('disabled', false);
			}else{
				if (this.data.is_view) {
					this.el.find('.ui-width').attr('disabled', true);
				} else {
					this.el.find('.ui-width').attr('disabled', false);
				}
			}

		    //回显
		    if (this.data.value) {
			    this.el.find(".textArea").val(this.data.value);
		    } else {
			    this.el.find(".textArea").val('');
		    }
	    },
		bindInputEvent(){
			let _this=this;
			this.el.find('.textArea').on('input',_.debounce(function(){
				_this.data.value=$(this).val();
				_this.events.changeValue(_this.data);
			},300));
		},
		iconCheck(){
			this.el.find('.ui-width').css('width',this.data.width);
			if(this.data.is_view){
				this.el.find('.ui-width').attr('title', this.data.value)
				this.el.find('.ui-width').attr('readonly','readonly').css({'background':'#EBEBE4','color':'#666666'});
			}else{
				this.el.find('.ui-width').removeAttr("readonly");
			}
			if(this.data.history){
				this.el.find('.ui-history').css('visibility','visible');
			}
		}
	},
    binds:[
        {
            event: 'click',
            selector: '.ui-history',
            callback: function(){
                this.events.emitHistory(this.data);
            }
        }
    ],
    afterRender(){
       this.actions.iconCheck();
       this.actions.init();
    },
    beforeDestory(){
        this.el.find('input').off();
        this.el.off();
    }
}
let TextAreaControl = Component.extend(config)
export default TextAreaControl;

let WXconfig={
	data:{controlHtml:WXtemplate},
	actions:Object.assign({},config.actions,{
		bindInputEvent(){
			let _this=this;
			this.el.find('.textArea').on('input',_.debounce(function(){
				_this.data.value=$(this).val();
			},300));
		},
	}),
	afterRender(){
		this._super.afterRender();
		this.el.find(' .form-control').css('height','50%');
		this.actions.init();
	},
	beforeDestory:config.beforeDestory
}
let TextAreaWX=BaseControl.extend(WXconfig);
export {TextAreaWX}


// WEBPACK FOOTER //
// app/components/form/textarea-control/textarea-area.js